<div class="market-search-result-popover" [routerLink]="'/' + translate.getActiveLang() + category.url(ExtendedOrderType.Market)">
    <img class="popover-header-image" [src]="category.image" [alt]="category.title">
    <div class="popover-content">
        <h3 class="popover-title">{{ category.title }}</h3>
        <p class="brief" [hidden]="!category.description">{{ category.description }}</p>
        <a class="popover-visit-page-link">{{ 'market.search.popoverLink.category' | transloco }}</a>
    </div>
</div>